const fillProductBrands = (productBrands) => {
  return { type: 'FILL_PRODUCT_BRANDS', payload: productBrands };
};

export {
  fillProductBrands,
}